"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  CharacterCounter: true
};
exports.default = exports.CharacterCounter = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Tooltip = require("../Tooltip/Tooltip");
var _Icon = require("../Icon/Icon");
var _CharacterCounter = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./CharacterCounter.css") : void 0);
var _CharacterCounter2 = require("./_CharacterCounter.types");
Object.keys(_CharacterCounter2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CharacterCounter2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CharacterCounter2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-character-counter';
const CharacterCounter = exports.CharacterCounter = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(CharacterCounter, _props)) : _props;
  const {
      id,
      localizedText,
      characterLimit,
      iconProps,
      currentInputLength = 0,
      targetProps,
      textProps,
      placement = ['top', 'bottom', 'left', 'right']
    } = props,
    otherProps = __rest(props, ["id", "localizedText", "characterLimit", "iconProps", "currentInputLength", "targetProps", "textProps", "placement"]);
  const classnames = _bind.default.bind(_CharacterCounter.default);
  const counterClasses = classnames(CSS_BLOCK, targetProps === null || targetProps === void 0 ? void 0 : targetProps.className, {
    [`${CSS_BLOCK}--exceeded`]: currentInputLength > characterLimit
  });
  const tooltipMessage = currentInputLength > characterLimit ? localizedText === null || localizedText === void 0 ? void 0 : localizedText.exceededCountWarning : `${localizedText === null || localizedText === void 0 ? void 0 : localizedText.counterTooltipMessage} ${characterLimit - (currentInputLength || 0)}`;
  return /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, Object.assign({}, otherProps, {
    message: tooltipMessage,
    placement: placement
  }), /*#__PURE__*/_react.default.createElement("span", Object.assign({}, targetProps, {
    ref: ref,
    "aria-label": tooltipMessage,
    className: counterClasses,
    id: id,
    role: "status"
  }), currentInputLength > characterLimit && (/*#__PURE__*/_react.default.createElement(_Icon.Icon, Object.assign({}, iconProps, {
    ariaHidden: true,
    iconName: "no",
    forceSize: "xs"
  }))), /*#__PURE__*/_react.default.createElement("span", Object.assign({}, textProps, {
    className: classnames(`${CSS_BLOCK}__text`, textProps === null || textProps === void 0 ? void 0 : textProps.className)
  }), `${currentInputLength || 0}/${characterLimit}`)));
});
CharacterCounter.displayName = 'CharacterCounter';
var _default = exports.default = CharacterCounter;